export const MAX_TOPIC_USAGES_FOR_BROADCAST_PROMOTION = 5
export const MAX_SUBSCRIBERS_FOR_BROADCAST_ONBOARDING = 5
export const MIN_SUBSCRIBERS_FOR_BROADCAST_PROMOTION = 4
